import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getVendors, postDeleteRentalVendor } from '../../../api/rentals';
import AddButton from '../../../reusable-components/basic-buttons/AddButton';
import EditIconButton from '../../../reusable-components/basic-buttons/EditIconButton';
import { ConfirmDialog } from '../../../reusable-components/confirm-dialog';
import CustomDataGrid from '../../../reusable-components/datagrid/CustomDataGrid';
import { RENTAL_VENDORS } from '../../../reusable-components/datagrid/rentalColumns';
import { useScopeCheck } from '../../../reusable-components/scopes/useScopeCheck';
import { useSnackbar } from '../../../reusable-components/snackbar';
import RentalVendorForm from './RentalVendorForm';

const RentalVendorsTab = () => {
  const canEditRentalVendors = useScopeCheck(['Rental-Vendor-Edit'], true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [row, setRow] = useState(null);
  const [rows, setRows] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const fetchData = async () => {
    try {
      setDataLoaded(false);
      const response = await getVendors();
      setRows(response.data);
      setDataLoaded(true);
    } catch (error) {
      console.error('Error fetching vendor data:', error);
      setDataLoaded(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const deleteVendor = async (id) => {
    try {
      const response = await postDeleteRentalVendor(id);
      if (!response?.success) {
        enqueueSnackbar(response?.message || 'Unable to delete rental vendor.', { variant: 'error' });
        return;
      }
      enqueueSnackbar('Rental vendor deleted successfully.', { variant: 'success' });
      await fetchData();
    } catch {
      enqueueSnackbar('Unable to delete rental vendor.', { variant: 'error' });
    }
  };

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    id: 'actions',
    width: 120,
    sortable: false,
    renderCell: (params) => <>
      <EditIconButton onClick={() => { setRow(params.row); setOpenForm(true); }} />
      <ConfirmDialog
        icon="delete-outline"
        color="error"
        content={`Are you sure you want to delete rental vendor ${params.row.name}?`}
        actionButton="Delete"
        action={() => deleteVendor(params.row.id)}
      />
    </>,
  };

  return (
    <>
      <Helmet>
        <title>Rental Vendors | Platform Solutions</title>
      </Helmet>

      <CustomDataGrid
        gridId="rental-vendors"
        boxSX={{ width: '100%', height: 'calc(100vh - 260px)' }}
        data={rows}
        gridColumns={canEditRentalVendors ? [...RENTAL_VENDORS, actions] : RENTAL_VENDORS}
        CustomLeftToolbar={canEditRentalVendors ? () => <AddButton onClick={() => { setRow(null); setOpenForm(true); }}>Add Vendor</AddButton> : undefined}
        pinnedColumns={canEditRentalVendors ? { right: ['actions'] } : undefined}
        isLoading={!dataLoaded}
        sort={[{ field: 'name', sort: 'asc' }]}
      />
      <RentalVendorForm
        open={openForm}
        row={row}
        onClose={() => { setRow(null); setOpenForm(false); }}
        onSaved={fetchData}
      />
    </>
  );
};

export default RentalVendorsTab;
